export const MODULE_NAME = 'Pedigrees';

export const spreadSheetsModuleName = 'SPREADSHEETS';